import React from "react";
import styles from "./Home.module.css";
import Header from "../../shared/Header/Header";
import Footer from "../../shared/Footer/Footer";
import Hero from "./Hero/Hero";
import Features from "./Features/Features";
import Expertise from "./Expertise/Expertise";
import CtaStrip from "./CtaStrip/CtaStrip";
import News from "./News/News";
import Services from "./Services/Services";
import Testimonials from "./Testimonials/Testimonials";

export default function Home() {
  return (
    <div className={styles.page}>
      <Header />

      <main id="top">
        <Hero />

        <Features />

        <Expertise />

        <CtaStrip />

        <News />

        <Services />

        <Testimonials />
      </main>

      <Footer />
    </div>
  );
}
